import React, { useEffect, useState } from 'react'
import { ANONYMOUS_QUESTION_TEMPLATE, SKIN_AGE, SKIN_ASM_CONSTANTS } from '../../../../../../common/skinAssessmentConstant';
import SkinAssessmentButton from '../../../../../../common/skinAssessmentButton/SkinAssessmentButton';
import './SkinAssessmentAge.scss';

const SkinAssessmentAge = ({ onAnswerSelect }) => {

    const [age, setAge] = useState(SKIN_AGE);

    useEffect(() => {
        const savedAge = sessionStorage.getItem('skinAssessmentAge');
        if (!savedAge) return;

        setAge(prev =>
            prev.map(item => ({
                ...item,
                active: item.key === savedAge,
            }))
        );
    }, []);

    const handerAgeSelect = index => {
        const updatedAge = age.map((item, i) => ({
            ...item,
            active: i === index
        }));
        setAge(updatedAge);
        const selectedAge = updatedAge.find(el => el.active);
        sessionStorage.setItem('skinAssessmentAge', selectedAge?.label);
        onAnswerSelect({ canGoNext: true, nextLabel: SKIN_ASM_CONSTANTS.M1, question_id: ANONYMOUS_QUESTION_TEMPLATE.AGE.question_id, question_label: ANONYMOUS_QUESTION_TEMPLATE.AGE.question_label, answer_ids: [selectedAge.key] });
    }

    return (
        <div className='age-container'>
            <div className='age-title'>
                <h5 className='age-title-text'>
                    {SKIN_ASM_CONSTANTS.USER_AGE_QUES}
                </h5>
            </div>
            <div className='age-content'>
                {
                    age?.map((el, index) => {
                        return (
                            <SkinAssessmentButton
                                key={`age=${index}`}
                                onBtnClick={() => handerAgeSelect(index)}
                                btnClassName={`age-btn ${el.active ? 'home-start-gradient' : ''}`}>
                                {el.label}
                            </SkinAssessmentButton>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default SkinAssessmentAge
